import { complement, isNil } from 'ramda'

export type Maybe<T> = T | null | undefined

export const exists = complement(isNil) as <T>(t: T) => t is NonNullable<T>
